export default "__VITE_ASSET__DKkxw6t2__"